import {
  Flex,
  Box,
  Card,
  CardHeader,
  Heading,
  CardBody,
  Image,
  IconButton,
  Select,
} from "@chakra-ui/react";
import PaperEditorConversationPanel from "../components/PaperEditorConversationPanel.tsx/PaperEditorConversationPanel";
import { OutlineNode } from "../types/Writer/OutlineNode";
import CrossReferencePanel from "../components/PaperEditorComponents/CrossReferencePanel";
import CitationPanel from "../components/PaperEditorComponents/CitationPanel";
import LatexPanel from "../components/PaperEditorComponents/LatexPanel";
import HistoryPanel from "../components/PaperEditorComponents/HistoryPanel";
import { MinusIcon } from "@chakra-ui/icons";
import React, { useState } from "react";
import { Function1 } from "lodash";
import { useRecoilValue } from "recoil";
import { selectedOutlineNodeId } from "../atoms/rootAtom";
import { pxToRem } from "../utils/editor.ts";
import useOutlineStore from "../stores/modules/outline.ts";

type EditorModelRightProps = {
  editor: any
  paperId: string
  onAddLabel: Function1<OutlineNode[], void>;
  isHistoryOpen: boolean;
  closeHistoryPanel: () => void;
}

// 定义库面板类型
type LibraryPanelType = 'crossReference' | 'citation' | 'latexPackage';

const EditorModelRight: React.FC<EditorModelRightProps> = ({ paperId, editor, isHistoryOpen, closeHistoryPanel }) => {
  const [isLibraryOpen, setIsLibraryOpen] = useState<boolean>(true);
  const [selectedPanel, setSelectedPanel] = useState<LibraryPanelType>('crossReference');
  const selectedNodeId = useRecoilValue(selectedOutlineNodeId);
  const { outline } = useOutlineStore();


  const togglePanelCollapse = () => {
    setIsLibraryOpen(!isLibraryOpen);
  };

  // 处理面板类型变更
  const handlePanelChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedPanel(e.target.value as LibraryPanelType);
  };

  return (
    <Flex
      flexDir={"column"}
      w={pxToRem(480)}
      h={"100%"}
      position={"relative"}
      overflow={"hidden"}
      transition={"all 0.5s ease"}
    >
      {isHistoryOpen ? (
        <HistoryPanel 
          isOpen={isHistoryOpen} 
          onClose={closeHistoryPanel} 
        />
      ) : (
        <>
          <Card
            mt={0}
            mb={4}
            bg={"#ffffff"}
            border={"1px solid #ccc"}
            borderRadius={"25px"}
            boxShadow={'none'}
            h={isLibraryOpen ? pxToRem(320) : pxToRem(60)}
            transition={"all 0.5s ease"}
          >
            <CardHeader px={4} pt={3} pb={2}>
              <Flex flexDir={"row"} justifyContent={"space-between"}>
                <Flex flexDir={"row"} alignItems={"center"}>
                  <Image
                    w={pxToRem(20)}
                    src="/static/editor/note-2.svg"
                    alt="Doenba"
                    mr={2}
                  />
                  <Heading size="md">Referencing</Heading>
                </Flex>
                <Box>
                  <IconButton
                    onClick={togglePanelCollapse}
                    aria-label="library-collapse"
                    color={"#8391BC"}
                    icon={<MinusIcon />}
                    size={"sm"}
                    variant={"ghost"}
                  />
                </Box>
              </Flex>
            </CardHeader>
            <CardBody overflow={"hidden"} maxH={"35vh"} px={'1rem'} py={0}>
              <Flex justifyContent="space-between" alignItems="center">
                <Select 
                  value={selectedPanel} 
                  onChange={handlePanelChange} 
                  size="md" 
                  mt={2}
                  mb={3}
                  width={pxToRem(196)}
                  borderRadius={pxToRem(10)}
                  border={"1px solid #ccc"}
                  _focus={{
                    borderColor: "#B1D6FF",
                    boxShadow: "0 0 0 1px #B1D6FF",
                  }}
                >
                  <option value="crossReference">Cross Reference</option>
                  <option value="citation">Citation</option>
                  <option value="latexPackage">LaTeX Preamble</option>
                </Select>
              </Flex>
              <Box mt={2}>
                {/* 使用条件显示而不是条件渲染，保持组件状态 */}
                <Box display={selectedPanel === 'crossReference' ? 'block' : 'none'}>
                  <CrossReferencePanel editor={editor} outline={outline} />
                </Box>
                <Box display={selectedPanel === 'citation' ? 'block' : 'none'}>
                  <CitationPanel editor={editor} paperId={paperId} />
                </Box>
                <Box display={selectedPanel === 'latexPackage' ? 'block' : 'none'}>
                  <LatexPanel paperId={paperId} />
                </Box>
              </Box>
            </CardBody>
          </Card>
          <Card
            bg={"#ffffff"}
            border={"1px solid #ccc"}
            borderRadius={"25px"}
            boxShadow={'none'}
            h={isLibraryOpen ? "calc(100% - 20.625rem)" : "calc(100% - 4.375rem)"}
            transition={"all 0.5s ease"}
          >
            <CardBody overflow={'hidden'}>
              <PaperEditorConversationPanel
                selectedNodeId={selectedNodeId}
                setSelectedNodeId={undefined}
                outlineNodes={undefined}
              />
            </CardBody>
          </Card>
        </>
      )}
    </Flex>
  );
};
export default EditorModelRight;